<mat-form-field
  #formFieldContainer
  floatLabel="always"
  class="drop-down-open-class"
  #chipsWrapper
  (click)="clickInput(input, chipsWrapper)"
>
  <mat-label #labelContainer (click)="toggleTooltip(tooltip)" class="{{ componentDefinition?.mandatory ? 'mandatory' : '' }}">
    {{ componentDefinition?.label }}
  </mat-label>
  <div
    class="labelToolTipContainer"
    #tooltip="matTooltip"
    matTooltip="{{ componentDefinition.label }}"
    [matTooltipDisabled]="showToolTip(tooltip, formFieldContainer, labelContainer)"
  ></div>
  <mat-chip-list #dropdownOpenChipList aria-label="{{componentDefinition?.label}}" [disabled]="disabled">
    <input
      placeholder="Select or enter value"
      #input
      [disabled]="disabled"
      value='{{formControl.value}}'
      [formControl]="formControl"
      [matAutocomplete]="auto"
      [matChipInputFor]="dropdownOpenChipList"
      (keyup)="keyPressUp($event)"
      (keydown)="keyDown($event)"
      (paste)="onPaste($event)"
      (blur)="onBlur($event)"
    />
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected) ='onSelect($event)'>
    <mat-option *ngFor="let selectedOption of filteredOptions" [value]="selectedOption">
      {{ selectedOption }}
      <span class="drop-down-open-remove-option" (click)="removeHandler($event, selectedOption)" [hidden]="(componentDefinition.dropDownList.indexOf(selectedOption) !== -1)">×</span>
    </mat-option>
  </mat-autocomplete>
  <button matSuffix type="button" [disabled]="disabled" class="mat-button hidden-print drop-down-arrow mat-select-arrow" title="">
    <i class="material-icons" (click)="clickInput(input,chipsWrapper)">arrow_drop_down</i>
  </button>
</mat-form-field>
